import { Check, Lock } from 'lucide-react';

const ANAKA_ICON = '/assets/anaka_icon.png';

export type StatusMarkKind = 'logo' | 'check' | 'lock' | 'error';

/**
 * Static end-state marks the auth surface resolves to: the logo at rest,
 * the verified tick (success), and the timed-out / error lock.
 */
export function StatusMark({ kind = 'logo', size = 92 }: { kind?: StatusMarkKind; size?: number }) {
  const base = {
    width: size,
    height: size,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    flex: '0 0 auto' as const,
  };

  if (kind === 'check') {
    return (
      <div
        style={{
          ...base,
          color: '#fff',
          // success green; no 3-stop token exists, literal per design
          background: 'linear-gradient(135deg, #16a34a, #22c55e)',
          boxShadow: '0 10px 30px rgba(34, 197, 94, 0.34)',
        }}
        aria-hidden="true"
      >
        <Check style={{ width: size * 0.46, height: size * 0.46 }} strokeWidth={1.9} />
      </div>
    );
  }

  if (kind === 'lock' || kind === 'error') {
    return (
      <div
        className="bg-secondary border border-border text-foreground"
        style={base}
        aria-hidden="true"
      >
        <Lock style={{ width: size * 0.42, height: size * 0.42 }} strokeWidth={1.9} />
      </div>
    );
  }

  return (
    <div className="bg-secondary border border-border" style={base} aria-hidden="true">
      <img
        src={ANAKA_ICON}
        alt=""
        style={{ width: size * 0.56, height: size * 0.56, objectFit: 'contain' }}
      />
    </div>
  );
}
